import React, { useState, useEffect } from "react";
import "../../assets/css/tables.css";
import testBluePng from "../../assets/images/notes/logs.svg";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom";
import Modal from "react-modal";
import x_mark from "../../assets/images/courses/group.svg";

const customStyles = {
    content: {
        top: "50%",
        left: "58%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "20px 30px",
        width: "60%",
        zIndex: "9000",
        maxHeight: "600px",
    },
};

const StudyLogsTable = ({ data }) => {
    const history = useHistory();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [note, setNote] = useState(false);

    function convertToUserTimezone(datetimeString) {
        const specificDateTime = moment(datetimeString, moment.ISO_8601);
        const userTimezone = moment.tz.guess();
        return specificDateTime.tz(userTimezone);
    }

    function openTest(file) {
        let type = file.type;
        if (file.result[0] != undefined) {
            history.push({
                pathname: `answerQuestions`,
                state: {
                    type,
                },
                search: `id=${file.id}`,
            });
        }
    }
    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    const thumbs = data?.map((file, i) => {
        return (
            <div key={i} className="logsContent">
                <div
                    className="parentLogsDiv "
                    onClick={(e) => {
                        openTest(file);
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={testBluePng} alt="testPng" />
                        </div>
                        <div>
                            <div className="mt-3">
                                <span>{file.note_name}</span>
                                <p>{file.note_description}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" notesFildsParrent">
                    <div
                        className="resultLogs cursorPointer viewNote"
                        onClick={() => {
                            setNote(file.notes);
                            openModal();
                        }}
                    >
                        VIEW NOTE
                    </div>
                    <div className="notesFilds">
                        <div
                            className="resultLogs cursorPointer"
                            onClick={() => {
                                openTest(file);
                            }}
                        >
                            {file.type == "flashcard"
                                ? "Flashcards"
                                : file.type == "choice"
                                ? "Multiple Choice"
                                : file.type == "written"
                                ? "Written"
                                : ""}
                        </div>

                        <div className="resultLogs">
                            {file.score ? file.score : "0"}%
                        </div>

                        <div className="resultLogs">
                            {convertToUserTimezone(file.updated_at).format(
                                "MMM D, YYYY, HH:mm"
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <div>
            <div className="divTable mt-4"> {thumbs} </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="showNotes">
                    <h2>Note</h2>
                    <img
                        src={x_mark}
                        onClick={closeModal}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <div>
                        <div
                            className="modalSpanNote"
                            dangerouslySetInnerHTML={{ __html: note }}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default StudyLogsTable;
